export class TalentGeneralAdapter {

  static toServer(data) {
    const toReturn = {
      name: data.name,
      phone: {
        countryCode: data.phoneCode,
        phoneNumber: data.phone
      },
      jobTitle: data.jobTitle,
      jobTitles: data.jobTitles && data.jobTitles.length ? data.jobTitles : [],
      jobTitleLevel: data.jobTitleLevel ? data.jobTitleLevel : 'middle',
      expectedSalary: {
        amount: data.salaryAmount,
        currency: data.salaryCurrency,
        period: data.salaryPeriod
      },
      salary: data.salary ?? null,
      location: {
        country: data.country
      },
      relocationPossibility: data.relocation,
      isIncognito: data.incognito
    };
    return toReturn;
  }

  static toForm(data) {
    const toReturn = {
      name: data.name || null ,
      phoneCode: data.phone && data.phone.countryCode ? data.phone.countryCode : '+44',
      phone: data.phone && data.phone.phoneNumber ? data.phone.phoneNumber : null,
      jobTitle: data.jobTitle || null,
      jobTitles: data.jobTitles || null,
      jobTitleLevel: data.jobTitleLevel || 'middle',
      country: data.location && data.location.country ? data.location.country : null,
      salaryPeriod: data.expectedSalary && data.expectedSalary.period ? data.expectedSalary.period : null,
      salaryCurrency: data.expectedSalary && data.expectedSalary.currency ? data.expectedSalary.currency : 'USD',
      salaryAmount: data.expectedSalary && data.expectedSalary.amount ? data.expectedSalary.amount : null,
      salary: data.salary ?? null,
      relocation: data.relocationPossibility,
      incognito: !!data.isIncognito
    }
    return toReturn;
  }

}

export class TalentSkillsAdapter {

  static toViewMerge(preset, userSkills) {
    if (preset && preset.length) {
      const clearSkillsAdds = { experience: 0, years: 0 };
      const prefilledTree = preset.map(branch => {
        if (!userSkills) { 
          return { ...branch, skills: branch.skills.map(skill => ({ ...skill, ...clearSkillsAdds })) }; 
        }
        const canMergeBranch = userSkills.find(b => b.id === branch.id);
        if (canMergeBranch) {
          const skillsToAdd = branch.skills.filter(skill => !canMergeBranch.skills.find(s => s.id === skill.id))
            .map(val => ({ id: val.id, name: val.name, ...clearSkillsAdds }));
          return { ...branch, skills: [ ...canMergeBranch.skills, ...skillsToAdd ]};
        } else {
          return { ...branch, skills: branch.skills.map(val => ({ id: val.id, name: val.name, ...clearSkillsAdds })) };
        }
      });
      if (!userSkills) { return prefilledTree; }
      const branchesToAdd = userSkills.filter(branch => !prefilledTree.find(b => b.id === branch.id));
      return [ ...prefilledTree, ...branchesToAdd ];
    }
    return null;
  }

  static toView(branches) {
    if (branches && branches.length) {
      const toReturn = branches.map(branch => ({
        id: branch.id,
        name: branch.name,
        skills: branch.skills.map(skill => ({
          id: skill.id,
          name: skill.name,
          experience: 0,
          years: 0
        }))
      }))
      return toReturn;
    }
    return null;
  }

  static toServer(skills) {
    const toReturn = skills.reduce((filtered, item) => {
      if (item.skills && item.skills.length && item.skills.some(val => val.experience || val.years)) {
        filtered.push({ ...item, skills: item.skills.filter((item: any) => item.experience) });
      }
      return filtered;
    }, [])
    return toReturn;
  }
  
}

export class PartnerGeneralAdapter {

  static toServer(data) {
    const toReturn = {
      name: data.name,
      phone: {
        countryCode: data.phoneCode,
        phoneNumber: data.phone
      },
      location: {
        country: data.country,
        city: data.city
      }
    };
    return toReturn;
  }

  static toForm(data) {
    const toReturn = {
      name: data.name || null ,
      phoneCode: data.phone && data.phone.countryCode ? data.phone.countryCode : '+44',
      phone: data.phone && data.phone.phoneNumber ? data.phone.phoneNumber : null,
      country: data.location && data.location.country ? data.location.country : null,
      city: data.location && data.location.city ? data.location.city : null
    }
    return toReturn;
  }
}

export class HmGeneralAdapter {

  static toServer(data) {
    const toReturn = {
      name: data.name,
      phone: {
        countryCode: data.phoneCode,
        phoneNumber: data.phone
      },
      jobPosition: data.jobPosition,
      company: {
        id: data.company.id,
      }
    };
    return toReturn;
  }

  static toForm(data) {
    const toReturn = {
      name: data.name,
      phoneCode: data.phone && data.phone.countryCode ? data.phone.countryCode : '+44',
      phone: data.phone && data.phone.phoneNumber ? data.phone.phoneNumber : null,
      jobPosition: data.jobPosition ? data.jobPosition : null,
      company: {
        id: data.company && data.company.id ? data.company.id : null,
        name: data.company && data.company.name ? data.company.name : null,
        country: data.company && data.company.location && data.company.location.country ? data.company.location.country : null,
      }
    }
    return toReturn;
  }
}
